import lineHeight from 'line-height';
import shave from 'shave';
import _debounce from 'lodash/debounce';

const defaults = {
  el: null,
  limitRows: 3,
};

export default class LimitRows {
  constructor(props) {
    const options = Object.assign({}, defaults, props);

    if (!options.el) {
      return;
    }

    this.el = options.el;
    this.limitRows = this.el.dataset.limitRows || options.limitRows;
    this.stopBreakpoint = this.el.dataset.stopBreakpoint || Infinity;

    this.resize = this.resize.bind(this);
    this.resize_debounced = _debounce(this.resize, 100);
    this.init();
  }

  get height() {
    return window.innerWidth < this.stopBreakpoint ? Infinity : lineHeight(this.el) * this.limitRows;
  }

  resize() {
    shave(this.el, this.height);
  }

  init() {
    this.resize();

    $(window).on('resize', this.resize_debounced);
  }

  destroy() {
    $(window).off('resize', this.resize_debounced);
  }
}



// WEBPACK FOOTER //
// ./scripts/utils/LimitRows.js